import React from 'react';
import classnames from 'classnames';
import { WrapperItem } from '../components/wrapper-item';
import { Section } from '../components/section';
import { Column } from '../components/column';
import { Image } from '../components/image';
import { Text } from '../components/text';
import { LinkWrapper } from '../components/link-wrapper';
import { shorthand } from '../utils/css-utils';
import { mobileFullWidthColumnClassName } from '../utils/defaults';
export var SectionLink = function (props) {
    var section = props.section, cssClass = props.cssClass, isRtl = props.isRtl, columnCssClass = props.columnCssClass;
    var imageUrl = section.imageUrl, innerPadding = section.innerPadding, outerPadding = section.outerPadding, columnsWidths = section.columnsWidths;
    if (innerPadding === undefined) {
        return null;
    }
    var direction = isRtl ? 'rtl' : 'ltr';
    var textAlign = isRtl ? 'right' : 'left';
    var imagePadding = isRtl
        ? innerPadding.top + "px " + innerPadding.right + "px " + innerPadding.bottom + "px 20px"
        : innerPadding.top + "px 20px " + innerPadding.bottom + "px " + innerPadding.left + "px";
    var textRightPadding = isRtl
        ? imageUrl
            ? '0px'
            : innerPadding.left + "px"
        : innerPadding.right + "px";
    var textLeftPadding = isRtl
        ? innerPadding.left + "px"
        : imageUrl
            ? '0px'
            : innerPadding.right + "px";
    return (React.createElement(WrapperItem, null,
        React.createElement(Section, { backgroundColor: section.backgroundColor, borderBottom: section.borderBottom, borderLeft: section.borderLeft, borderRight: section.borderRight, borderTop: section.borderTop, cssClass: cssClass, padding: shorthand(outerPadding), direction: direction },
            section.imageUrl && (React.createElement(Column, { cssClass: classnames(columnCssClass, 'section-link-image', section.imageCssClass, mobileFullWidthColumnClassName), padding: imagePadding, width: columnsWidths[0] },
                React.createElement(Image, { cssClass: "so-link-image", src: section.imageUrl, href: section.link, padding: "0" }))),
            React.createElement(Column, { width: imageUrl ? columnsWidths[1] : '100%', cssClass: classnames(columnCssClass, section.textCssClass, imageUrl ? 'section-link-text' : '', mobileFullWidthColumnClassName), paddingTop: innerPadding.top + "px", paddingBottom: innerPadding.bottom + "px", paddingRight: textRightPadding, paddingLeft: textLeftPadding },
                React.createElement(Text, { padding: "0px", align: textAlign },
                    React.createElement("a", { className: "so-global-h3 so-link-href", href: section.link, target: "_blank", rel: "noopener noreferrer" },
                        React.createElement(LinkWrapper, { fontWeight: "inherit" }, section.title)),
                    React.createElement("p", { className: "so-global-p2" }, section.description))))));
};
//# sourceMappingURL=section-link.js.map